export default __webpack_public_path__ + "static/meshery-playground-alt-4-ba35ab40ee1e95fec6837a760b523e59.webp";